import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

import Navigation from '../layouts/navigation.js'
import Footer from '../layouts/footer.js'

import seo_img from '../img/seo/seo-1.svg'
import seo_img_2 from '../img/seo/seo-2.svg'

import register_now from '../img/register-now-left.svg'

import ogp_cover from '../img/cover.png'

export default class Seo extends React.Component {

	pageClick(e) {
		document.getElementsByTagName('body')[0].className=''
	}

	componentDidMount() {
	    var mask = document.getElementById('mask');
	    mask.addEventListener('touchstart', this.pageClick, false);
	}

	render() {
		return (
			<div>

				<Helmet
					title="Get Paid for Writing - UvoCorp.com"
					meta={[
						{ name: "description", content: "Get paid to write online, online writing jobs. Apply for a  job online with UvoCorp.com. Registration is free." },

						{ property: 'og:title', content: "Get Paid for Writing - UvoCorp.com" },
						{ property: 'og:description', content: "Get paid to write online, online writing jobs. Apply for a  job online with UvoCorp.com. Registration is free." },
						{ property: 'og:site_name', content: "UvoCorp.com" },
						{ property: 'og:type', content: "website" },
						{ property: 'og:image', content: ogp_cover },
					]}
					link={[
						{ rel: 'canonical', href: "https://www.uvocorp.com/get_paid_to_write.html" }
					]} />

				<div className='header' id="header">
					<Navigation />
				</div>

				<div className="wrapper">
				
					<div className="inner-header">
						<div className="container">
							<h1>A Great Opportunity: Get Paid for Writing</h1>
							<Link to="/register_email.html">Register now</Link>
						</div>
					</div>

					<div className="home-benefits home-block hiring-benefits">
						<div className="container">
							<h1>The benefits you enjoy working as a freelance writer:</h1>
							<ul className="home-benefits-list">
								<li className="home-benefits-1">
									<p>No registration fees</p>
								</li>
								<li className="home-benefits-2">
									<p>High wages</p>
								</li>
								<li className="home-benefits-3">
									<p>Working from home</p>
								</li>
								<li className="home-benefits-4">
									<p>Orders in the sphere <br />of your interest</p>
								</li>
								<li className="home-benefits-5">
									<p>24/7 available <br />support team</p>
								</li>
								<li className="home-benefits-6">
									<p>Payments always <br />on time</p>
								</li>
								<li className="home-benefits-7">
									<p>Manage your time <br />and workload yourself</p>
								</li>
							</ul>
						</div>
					</div>

					<div className="home-pricing-info">
						<div className="container">
							<p>There is no other company that offers <strong>$15</strong>/page written by an <span className="home-pricing-info-role">ESL</span> writer and <strong>$26</strong>/page completed by an <span className="home-pricing-info-role">ENL</span> writer.</p>
							<Link to="/prices.html">View Pricing <svg id="arrow-right" width="22" height="22"><path fill="#black" d="M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z"/></svg></Link>
						</div>
					</div>

					<div className="inner-white hiring seo">
						<div className="container">
							<h2>Writers wanted</h2>
							<div className="row">
								<div className="col-md-9">
									<p>Dear potential <Link to="/">UVOCORP</Link> writers, we are currently hiring:</p>
									<ol className="hiring-steps">
										<li>Writers who are Native Speakers of English (these writers have exclusive access to orders which need to be written by a Native Speaker of English);</li>
										<li>English as a Second Language writers with a profound knowledge in Humanities, Business Studies, Applied, and Social Sciences;</li>
										<li>Writers with a profound knowledge in the following disciplines. Working only on them on a permanent basis is our internal separate project:</li>
									</ol>
								
									<ul className="hiring-disciplines">
										<li className="discipline_8">Accounting</li>
										<li className="discipline_15">Architecture, Building and Planning</li>
										<li className="discipline_14">Biology (and other Life Sciences)</li>
										<li className="discipline_13">Chemistry</li>
										<li className="discipline_1">Engneering</li>
										<li className="discipline_10">Civil Engineering</li>
										<li className="discipline_7">Computer Science</li>
										<li className="discipline_5">IT, Web</li>
										<li className="discipline_3">Finance</li>
										<li className="discipline_11">Mathematics</li>
										<li className="discipline_12">Physics</li>
										<li className="discipline_4">Statistics</li>
									</ul>
								</div>
								<div className="hiring-img">
									<img src={seo_img_2} alt="Seo Image"/>
								</div>
							</div>

							<div className="row seo-row">

								<div className="col-md-4 seo-img-container">
									<div className="seo-img">
										<img src={seo_img} alt="Seo Image"/>
									</div>
								</div>
								<div className="col-md-8">

									<p>Writers are often looking for opportunities to make money from their skills. Of course, they have families for which to provide, as well as other financial responsibilities. If you are an individual with good writing skills and a college degree, and you are interested in working from home, then we are interested in helping you get paid to write. You can employ your writing talent and specialized knowledge to earn money through us by writing for our clients. Working with our agency will allow you to have a flexible schedule while earning money. We presently have openings for writers with graduate degrees who are interested in freelancing with the opportunity to work from home.</p>
									<p>If you wish to earn money from writing, we can assist you in your endeavors. We offer the opportunity to earn money as it fits your needs through accessing orders as your schedule permits and get paid to write articles, and all sorts of assignments. Simply select the writing orders that attract you within the time frame that best fits your requirements. Retaining a writing position with us while working from home is a very simple, straightforward process. Payment for your services is provided through your choice of secure, easy payment methods. Our goal is to satisfy our customers’ requests with quality products that meet all customer requirements. To fill those orders, we must have access to high-level writers committed to supplying superior writing pieces. We know the value of providing our clients with excellent writers, and so we strive to treat our writers well, which includes timely payments for services.</p>
									<p>Earning money through working from home is desirable, perhaps even necessary, for many people. Our clients want online access to capable writers who can help them understand and complete writing assignments. As a writer for <Link to="/">UVOCorp</Link>, you have an opportunity to contribute to the success of individuals world-wide while receiving monetary compensation for your efforts. Our goals are to help address your financial needs through online, freelance writing opportunities and to satisfy our clients’ requests. Come join our team and experience getting paid from working at home utilizing your writing talents.</p>

								</div>
							</div>
						</div>
					</div>

					<div className="inner-registration inner-registration-left">
						<div className="container">
							<div className="inner-registration-image">
								<div className="img inner-registration-img">
									<img src={register_now} alt="Start registration"/>
								</div>
							</div>
							<div className="inner-registration-text">
								<div className="inner-registration-title">Register now <br />to start earning!</div>
								<div className="inner-registration-button">
									<Link to="/register_email.html">Start registration</Link>
								</div>
							</div>
						</div>
					</div>

					<Footer />

				</div>
				<div id="mask" className="c-mask"></div>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/get_paid_to_write.html.js